import { Button } from '@chakra-ui/react'
import { PageAlert } from 'BrokerTsLib/src/components'
import { useGetOrganizationUnitById } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { HeaderButton } from '@/components'
import { OrganizationDetail } from '@/containers/organization/OrganizationDetail'
import { OrganizationHeader } from '@/containers/organization/OrganizationHeader'
import { OrganizationTransferButton } from '@/containers/organization/OrganizationTransferButton'
import { useAuth } from '@/context/AuthContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { Edit, Refresh } from '@/icons'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import { Breadcrumbs } from 'BrokerTsLib/src/containers/Breadcrumbs'

export const OrganizationDetailPage = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const { organizationUnitId: organizationUnitIdStr } = useParams()
  const organizationUnitId = +organizationUnitIdStr!

  const { data, refetch, isLoading, isError } =
    useGetOrganizationUnitById(organizationUnitId)

  const breadcrumbs = useMemo(() => {
    const items = []

    if (user?.allowDisplayOrganizationStructure)
      items.push({ to: '/organization/list', label: 'Seznam organizací' })

    if (data?.data.superiorOrganizationUnitId)
      items.push({
        to: `/organization/${data?.data.superiorOrganizationUnitId}`,
        label: data.data.superiorOrganizationUnitName ?? 'Nadřízená organizace',
      })

    items.push({
      to: `/organization/${organizationUnitId}`,
      label: data?.data.name ?? 'Organizace',
      current: true,
    })

    return items
  }, [user, data])

  return isError ? (
    <PageAlert status="error" title="Chyba při načítání stránky">
      <Button colorScheme="red" isLoading={isLoading} onClick={() => refetch()}>
        <Refresh /> Obnovit stránku
      </Button>
    </PageAlert>
  ) : (
    <SidebarProvider>
      <PageWrapper
        header={
          <>
            <Breadcrumbs items={breadcrumbs} />
            <OrganizationHeader organization={data?.data} isLoading={isLoading}>
              {user?.allowEditOrganizationStructure && (<>
                <OrganizationTransferButton {...data?.data} />
                <HeaderButton
                  onClick={() =>
                    navigate(`/organization/${organizationUnitId}/edit`)
                  }
                  variant="solid"
                  colorScheme="primary"
                  _hover={{ bg: 'primary.600' }}
                >
                  <Edit />
                  Upravit
                </HeaderButton>
              </>
              )}
            </OrganizationHeader>
          </>
        }
        sidebar={<Sidebar />}
        mainProps={{
          sx: {
            pt: { base: 0, md: 8 },
            gap: 6,
            display: 'grid',
            alignContent: 'baseline',
          },
        }}
      >
        <OrganizationDetail organization={data?.data} isLoading={isLoading} />
      </PageWrapper>
    </SidebarProvider>
  )
}
